import { UsersActions, UsersActionType } from '../actions/userActions';
import { call, put, takeLatest } from 'redux-saga/effects';
import { Services } from '@card/commonlib';
import { CardUser } from '@card/types';
import { AxiosResponse } from 'axios';

function* fetchCardUser() {
  try {
    const response: AxiosResponse<CardUser> = yield call(Services.getCardUser);
    yield put(UsersActions.fetchSuccess(response.data));
  } catch (error) {
    yield put(UsersActions.fetchError(error));
  }
}

function* userSagas() {
  yield takeLatest(UsersActionType.Fetch, fetchCardUser);
}

export default userSagas;
